import { render } from "./EqStandardZhiZaoAdd.vue?vue&type=template&id=04127550&scoped=true"
import script from "./EqStandardZhiZaoAdd.vue?vue&type=script&lang=js"
export * from "./EqStandardZhiZaoAdd.vue?vue&type=script&lang=js"

import "./EqStandardZhiZaoAdd.vue?vue&type=style&index=0&id=04127550&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04127550"]])

export default __exports__